// extracted by mini-css-extract-plugin
export default {"wrap":"ShippingInfoAddModal_wrap__UAy4X","pure":"ShippingInfoAddModal_pure__i++9u","button":"ShippingInfoAddModal_button__vE9TP"};